import React from 'react';
import { Button, Text } from '@fragments';
import StudioUnavailable from '../../components/StudioUnavailable';
import Teleprompter from '../../components/Teleprompter';
import useMobileWorkspace from './hooks/useMobileWorkspace';

export default function MobileWorkspace({ studio: s }) {
  const { t } = s;
  const { projectId, legacy, status, revision, error, login } = useMobileWorkspace(s);
  if (!s.auth.signed) return <StudioUnavailable><Text.h4>{t('sameAccount')}</Text.h4><Text.p contrast={6}>{t('mobileHint')}</Text.p><Button onClick={login}>{t('login')}</Button></StudioUnavailable>;
  if (projectId) {
    if (status === 'ready') return <Teleprompter t={t} script={revision.script} revisionNumber={revision.revision_number} onClose={s.newChat} />;
    if (status === 'error') return <StudioUnavailable><Text.h4>{t(`error_${error}`)}</Text.h4><Button onClick={s.newChat}>{t('newChat')}</Button></StudioUnavailable>;
    return <StudioUnavailable><Text.h3 loading>{t('openScript')}</Text.h3></StudioUnavailable>;
  }
  return <StudioUnavailable><Text.h3>{t('mobilePreview')}</Text.h3><Text.p contrast={7}>{t('sameAccount')}</Text.p><Text.p contrast={6}>{t('mobileHint')}</Text.p>{legacy && <Text.p role="alert">{t('error_handoff')}</Text.p>}<Button onClick={s.newChat}>{t('newChat')}</Button></StudioUnavailable>;
}
